import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import Scroll from 'react-scroll'
import PropTypes from 'prop-types'

import WorkStudent from './WorkStudent'
import WorkInfos from './WorkInfos'
import WorkComments from './WorkComments'
import WorkResources from './WorkResources'
import WorkSidebarLoader from './WorkSidebarLoader'

import FaInfo from 'react-icons/fa/info-circle'
import FaComments from 'react-icons/fa/comments'

var Link = Scroll.Link
var Element = Scroll.Element
var scroll = Scroll.animateScroll
var scrollSpy = Scroll.scrollSpy

@autobind
class WorkSidebar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      clickedCta: false
    }
  }

  componentDidMount () {
    scrollSpy.update()
  }

  hideCommentCta () {
    this.setState({clickedCta: true})
    scroll.scrollToBottom({containerId: 'workSidebar__container'})
    setTimeout(() => document.getElementById('commentFormBody').focus(), 500)
  }

  render () {
    let work = this.props
    return (
      <aside className='workSidebar'>
        {!this.props.loading && work.id && <div>
          <div id='workSidebar__container' className='workSidebar__container'>
            <Element name='overviewScroll'>
              <WorkStudent {...work} />
              <WorkInfos {...work} />
            </Element>
            {work.status === 'published' && <WorkResources {...work} />}
            {work.status === 'published' && <Element name='commentsScroll'>
              <WorkComments {...work} hideCommentCta={this.hideCommentCta} user={this.props.user} />
            </Element>}
            {work.status !== 'published' && <div className='workSidebar__unpublished'>
              <FaInfo />
              <p>This work is in the evidence bank.</p>
              <p>Only you can access it.</p>
            </div>}
          </div>
          {work.status === 'published' && <nav className='workSidebar__nav'>
            {/* <div className={this.state.clickedCta ? 'workSidebar__nav__cta workSidebar__nav__cta--clicked' : 'workSidebar__nav__cta'}>
              <button className='btn btn-block btn-primary' onClick={this.hideCommentCta}>Let's leave {work.student && work.student.first_name} a great comment!</button>
            </div> */}
            {/* <div className='workSidebar__nav__buttons'>
              <Link className='workSidebar__nav__button workSidebar__nav__button' activeClass='workSidebar__nav__button--active' to='overviewScroll' containerId='workSidebar__container' duration={500} offset={0} spy smooth>
                <FaInfo />
                <span className='workSidebar__nav__title'>Overview</span>
              </Link>
              <Link className='workSidebar__nav__button' activeClass='workSidebar__nav__button--active' to='commentsScroll' containerId='workSidebar__container' duration={500} offset={0} spy smooth isDynamic>
                <FaComments />
                <span className='workSidebar__nav__title'>Comments</span>
              </Link>
            </div> */}
          </nav>}
        </div>}
        {(this.props.loading || !work.id) && <WorkSidebarLoader />}
      </aside>
    )
  }
}

export default WorkSidebar

WorkSidebar.propTypes = {
  loading: PropTypes.bool,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkSidebar.js